import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
import hoistStatics from "hoist-non-react-statics";
export var createHOC = function (config) {
  var _context,
    ComponentToWrap = config.component,
    Wrapper = config.wrapper,
    displayName = config.displayName,
    WrappedComponent = Wrapper(ComponentToWrap, function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
          _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
        });
      }
      return e;
    }({}, config.wrapperParams));
  return WrappedComponent.displayName = displayName || _concatInstanceProperty(_context = "".concat(Wrapper.name || "Wrapper", "(")).call(_context, ComponentToWrap.displayName || ComponentToWrap.name, ")"), WrappedComponent.WrappedComponent = ComponentToWrap, ComponentToWrap.propTypes && (WrappedComponent.propTypes = ComponentToWrap.propTypes), ComponentToWrap.defaultProps && (WrappedComponent.defaultProps = ComponentToWrap.defaultProps), hoistStatics(WrappedComponent, ComponentToWrap);
};